/**
 * 将markdown文本转换为html文本
 * 支持粗体和链接，如果是内部链接请@ 开头
 * @param {*} markdown 需要处理的markdown文本
 * @param {*} vueComponent 当前vue组件，会根据这个组件来处理路由
 */
export function parseMarkdown(markdown, vueComponent) {
    // 解析粗体字：**text** -> <strong>text</strong>
    const boldPattern = /\*\*(.*?)\*\*/g;
    markdown = markdown.replace(boldPattern, '<strong>$1</strong>');

    // 解析链接：[text](url) -> <a href="url">text</a>
    const linkPattern = /\[(.*?)\]\((.*?)\)/g;
    // 判断如果链接中包含@，则使用项目内相对路径
    markdown = markdown.replace(linkPattern, (match, p1, p2) => {
        let link = p2;
        if (p2.includes('@')) {
            // 使用vueComponent.$router.resolve来解析路由，这里会自动应用配置的路由前缀
            link = vueComponent.$router.resolve(p2.replace('@', '')).href;
        }
        return `<a href="${link}" target="_blank" class="seo-a">${p1}</a>`;
    });

    // 解析斜体：*text* -> <em>text</em>    
    const italicPattern = /\*(.*?)\*/g;
    markdown = markdown.replace(italicPattern, '<em>$1</em>');

    return markdown;
}